import styled from 'styled-components'
import Modal from '@/components/common/Modal'
import { device } from '@/common/constants/device'
import {
  ProfileModalTitle,
  ProfileText,
} from '@/components/Profile/ProfileStyled'
import BaseButtonClose from '@/components/common/BaseButtonClose'
import React from 'react'
import OfferPremiumCard from '@/components/Offers/OfferPremiumCard'
import { close } from '@/store/modalsSlice'
import { useDispatch } from 'react-redux'
import { userAmplitudeAnalytics } from '@/common/services/userAmplitudeAnalytics'
import { ANALYTIC_OFFER } from '@/common/constants/analytics'
import { getCookie } from 'cookies-next'
import { useTranslations } from 'next-intl'

const OfferModal = styled(Modal)`
  .modal-content {
    @media ${device.tablet} {
      width: 100%;
    }
  }

  .modal-inner-content {
    padding: 20px;
    z-index: 999;
    @media ${device.tablet} {
      padding: 30px;
    }
  }
`

const OfferModalTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const OfferModalForm = styled.form`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`
const Wrapper = styled.div`
  display: flex;
  gap: 8px;

  @media ${device.tablet} {
    gap: 24px;
    font-size: 12px;
    margin-top: 24px;
  }
`

const plans = [
  {
    description: 'Start',
    icon: 'start',
    advantages: [
      'start_advantage_1',
      'start_advantage_2',
      'start_advantage_3',
      'start_advantage_4',
      'start_advantage_5',
    ],
  },
  {
    description: 'Pro',
    icon: 'pro',
    advantages: [
      'pro_advantage_1',
      'pro_advantage_2',
      'pro_advantage_3',
      'pro_advantage_4',
      'pro_advantage_5',
    ],
  },
]

const OffersPremiumModal = ({ modalContent }) => {
  const t = useTranslations('offers')
  const dispatch = useDispatch()

  const onButtonCloseHandler = () => {
    let sessionsCount = Number(getCookie('sessionsCount')) || 0

    if (sessionsCount >= 14) {
      sessionsCount = 14
    } else if (sessionsCount >= 7) {
      sessionsCount = 7
    } else if (sessionsCount >= 3) {
      sessionsCount = 3
    }

    dispatch(close())
    userAmplitudeAnalytics.trackEvent(
      `${ANALYTIC_OFFER}_collapse_banner_close_clicked`,
      {
        trigger: `${sessionsCount}s search`,
      }
    )
  }

  return (
    <OfferModal maxWidth="644" needOffsetHeader>
      <OfferModalForm>
        <OfferModalTop>
          <ProfileModalTitle color="black-russian">
            {t(`${modalContent.title}`)}
          </ProfileModalTitle>
          <BaseButtonClose close={onButtonCloseHandler} />
        </OfferModalTop>
        <ProfileText>{t(`${modalContent.description}`)}</ProfileText>
        <Wrapper className="offers-container">
          {plans.map((plan, index) => (
            <OfferPremiumCard
              key={index}
              plan={plan}
              modalContent={modalContent}
            />
          ))}
        </Wrapper>
      </OfferModalForm>
    </OfferModal>
  )
}

export default OffersPremiumModal
